module.exports = __webpack_public_path__ + "media/images/marketing-banner/installation-3-c5d9522438c42890578ba52edeb88b02.png";